const handleVibrate = () => {
  navigator.vibrate(1000);
};

export default handleVibrate
